/**
 * Checkout público SaaS: cartão exige tokenização no Asaas.
 * Padrão oculto; REACT_APP_SAAS_CHECKOUT_CREDIT_CARD_ENABLED=true para reativar.
 */
export const SAAS_CHECKOUT_CREDIT_CARD_ENABLED =
  String(process.env.REACT_APP_SAAS_CHECKOUT_CREDIT_CARD_ENABLED || '').toLowerCase() === 'true';
